export default {
    getHeaderFields: state => state.headerFields,
    getFormActions: state => state.formActions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    getDataTableOptions: state => state.dataTableOptions,
    getSearchFields: state => state.searchFields,
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,

    getDataAssInvHeaderFields: state => state.dataAssInvHeaderFields,
    getDataAssInvFormActions: state => state.dataAssInvFormActions,
    getDataAssInvActions: state => state.dataAssInvActions,
    getDataAssInvRowActions: state => state.dataAssInvRowActions,
    getDataAssInvDataTableOptions: state => state.dataAssInvDataTableOptions,
    getDataAssInvSearchFields: state => state.dataAssInvSearchFields,
    isDataAssInvFormOpen: state => state.dataAssInvFormIsOpen,
    isDataAssInvGridOpen: state => state.dataAssInvGridIsOpen
}